(function () {
  'use strict';

  var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
  var MAX_LOGO_DIMENSION = 1200;
  var LOGO_JPEG_QUALITY = 0.9;
  var RETRY_DELAY_MS = 1500;

  var STORAGE_KEY = 'wf_logo_preview';
  var LOGO_PREVIEW_TTL_MS = 24 * 60 * 60 * 1000;

  var VISITOR_STORAGE_KEY = 'wf_lp_visitor_id';
  var UPLOAD_SESSION_ID = null;

  function generateUuid() {
    var d = Date.now();
    if (window.performance && typeof window.performance.now === 'function') {
      d += performance.now();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function getVisitorId() {
    try {
      var existing = localStorage.getItem(VISITOR_STORAGE_KEY);
      if (existing) return existing;
      var id = generateUuid();
      localStorage.setItem(VISITOR_STORAGE_KEY, id);
      return id;
    } catch (e) {
      if (!window.__wfVisitorId) window.__wfVisitorId = generateUuid();
      return window.__wfVisitorId;
    }
  }

  function getUploadSessionId() {
    if (!UPLOAD_SESSION_ID) {
      UPLOAD_SESSION_ID = generateUuid();
    }
    return UPLOAD_SESSION_ID;
  }

  var cartTokenCache = '';
  var cartTokenFetchPromise = null;

  function getCartTokenUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart.js';
    }
    return '/cart.js';
  }

  function normalizeCartToken(token) {
    if (!token) return '';
    var value = String(token).trim();
    var q = value.indexOf('?');
    return q === -1 ? value : value.slice(0, q);
  }

  function fetchCartToken() {
    if (cartTokenCache) return Promise.resolve(cartTokenCache);
    if (cartTokenFetchPromise) return cartTokenFetchPromise;
    cartTokenFetchPromise = fetch(getCartTokenUrl(), { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        cartTokenCache = normalizeCartToken(cart && cart.token ? cart.token : '');
        return cartTokenCache;
      })
      .catch(function () { return ''; })
      .finally(function () { cartTokenFetchPromise = null; });
    return cartTokenFetchPromise;
  }

  function resolveCartToken(modal) {
    var fromModal = normalizeCartToken(modal && modal.dataset.shopifyCartToken ? modal.dataset.shopifyCartToken : '');
    if (fromModal) return Promise.resolve(fromModal);
    return fetchCartToken();
  }

  function getStoredLogo() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || typeof data.dataUrl !== 'string' || typeof data.ts !== 'number') {
        try { localStorage.removeItem(STORAGE_KEY); } catch (e2) {}
        return null;
      }
      if (Date.now() - data.ts > LOGO_PREVIEW_TTL_MS) {
        try { localStorage.removeItem(STORAGE_KEY); } catch (e2) {}
        return null;
      }
      if (data.dataUrl.indexOf('data:image/') !== 0 || data.dataUrl.indexOf(';base64,') === -1) {
        try { localStorage.removeItem(STORAGE_KEY); } catch (e2) {}
        return null;
      }
      var out = { dataUrl: data.dataUrl, ts: data.ts };
      if (data.position && typeof data.position.left === 'number' && typeof data.position.top === 'number') {
        var left = Math.max(0, Math.min(100, data.position.left));
        var top = Math.max(0, Math.min(100, data.position.top));
        out.position = { left: left, top: top };
      }
      if (typeof data.size === 'number' && data.size >= 1 && data.size <= 100) {
        out.size = data.size;
      }
      if (typeof data.rotation === 'number' && data.rotation >= -360 && data.rotation <= 360) {
        out.rotation = data.rotation;
      }
      return out;
    } catch (e) {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e2) {}
      return null;
    }
  }

  function setStoredLogo(dataUrl, layout) {
    if (!dataUrl || typeof dataUrl !== 'string') return;
    try {
      var payload = { dataUrl: dataUrl, ts: Date.now() };
      if (layout) {
        if (layout.position && typeof layout.position.left === 'number' && typeof layout.position.top === 'number') {
          payload.position = {
            left: Math.max(0, Math.min(100, layout.position.left)),
            top: Math.max(0, Math.min(100, layout.position.top))
          };
        }
        if (typeof layout.size === 'number' && layout.size >= 1 && layout.size <= 100) {
          payload.size = layout.size;
        }
        if (typeof layout.rotation === 'number' && layout.rotation >= -360 && layout.rotation <= 360) {
          payload.rotation = layout.rotation;
        }
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  function clearStoredLogo() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function openModal(modal) {
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusable = modal.querySelector('button:not([disabled]), [href], input:not([disabled]), select, textarea');
    if (focusable) focusable.focus();
  }

  function closeModal(modal) {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function getFocusables(modal) {
    var sel = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(modal.querySelectorAll(sel), function (el) {
      return el.offsetParent !== null && !el.hasAttribute('disabled') && (el.getAttribute('tabindex') === null || el.getAttribute('tabindex') !== '-1');
    });
  }

  function trapFocus(modal, e) {
    if (e.key !== 'Tab') return;
    var focusables = getFocusables(modal);
    if (focusables.length === 0) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function compressImage(file) {
    return new Promise(function (resolve, reject) {
      if (!file || !file.type.startsWith('image/')) {
        resolve(file);
        return;
      }
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        URL.revokeObjectURL(url);
        var w = img.naturalWidth;
        var h = img.naturalHeight;
        if (w <= MAX_LOGO_DIMENSION && h <= MAX_LOGO_DIMENSION) {
          resolve(file);
          return;
        }
        var scale = Math.min(MAX_LOGO_DIMENSION / w, MAX_LOGO_DIMENSION / h, 1);
        var cw = Math.round(w * scale);
        var ch = Math.round(h * scale);
        var canvas = document.createElement('canvas');
        canvas.width = cw;
        canvas.height = ch;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, cw, ch);
        canvas.toBlob(function (blob) {
          if (blob) resolve(blob);
          else resolve(file);
        }, 'image/jpeg', LOGO_JPEG_QUALITY);
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        resolve(file);
      };
      img.src = url;
    });
  }

  function sendToBackend(url, body, isRetry) {
    if (!url) return Promise.resolve();
    return fetch(url, {
      method: 'POST',
      body: body,
      mode: 'cors'
    }).then(function (res) {
      if (!res.ok && !isRetry) {
        return new Promise(function (r) { setTimeout(r, RETRY_DELAY_MS); }).then(function () {
          return sendToBackend(url, body, true);
        });
      }
      return res;
    }).catch(function () {
      if (!isRetry) {
        return new Promise(function (r) { setTimeout(r, RETRY_DELAY_MS); }).then(function () {
          return sendToBackend(url, body, true);
        });
      }
    });
  }

  function initLogoPreview(triggerWrap) {
    var sectionId = triggerWrap.dataset.sectionId;
    if (!sectionId) return;

    var modal = document.getElementById('logo-preview-modal-' + sectionId);
    var trigger = triggerWrap.querySelector('.logo-preview-trigger');
    var overlay = document.getElementById('logo-preview-overlay-' + sectionId);
    var logoEl = document.getElementById('logo-preview-logo-' + sectionId);
    var logoImg = document.getElementById('logo-preview-img-' + sectionId);
    var productImage = modal && modal.querySelector('.logo-preview-modal__product-image');
    var input = modal && modal.querySelector('.logo-preview-input');
    var removeBtn = modal && modal.querySelector('.logo-preview-remove');
    var sizeInput = modal && modal.querySelector('.logo-preview-size');
    var sizeRow = modal && modal.querySelector('.logo-preview-controls__size');
    var rotationInput = modal && modal.querySelector('.logo-preview-rotation');
    var rotationRow = modal && modal.querySelector('.logo-preview-controls__rotation');
    var downloadBtn = modal && modal.querySelector('.logo-preview-download-btn');
    var emailInput = modal && modal.querySelector('.logo-preview-email-input');
    var emailErrorEl = modal && modal.querySelector('.logo-preview-email-error');
    var closeButtons = modal && modal.querySelectorAll('[data-close-modal]');
    var zoomViewport = modal && modal.querySelector('[data-zoom-viewport]');
    var zoomInner = modal && modal.querySelector('[data-zoom-inner]');
    var zoomOutBtn = modal && modal.querySelector('.logo-preview-zoom-out');
    var zoomInBtn = modal && modal.querySelector('.logo-preview-zoom-in');
    var zoomResetBtn = modal && modal.querySelector('.logo-preview-zoom-reset');

    var webhookBase = (modal && modal.dataset.webhookBase) ? modal.dataset.webhookBase.replace(/\/$/, '') : '';
    var askEmail = modal && modal.dataset.askEmailBeforeDownload === 'true';

    if (!modal || !trigger || !overlay || !logoEl || !logoImg || !input) return;

    var pos = { left: 20, top: 20 };
    var size = 35;
    var rotation = 0;
    var drag = null;
    var lastUploadedFile = null;
    var lastUploadDataUrl = null;

    var ZOOM_MIN = 0.5;
    var ZOOM_MAX = 2.5;
    var ZOOM_STEP = 0.25;
    var zoomLevel = 1;
    var zoomTranslateX = 0;
    var zoomTranslateY = 0;
    var pinchStartDist = null;
    var pinchStartZoom = null;
    var pan = null;

    function showLogo() {
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      if (removeBtn) removeBtn.classList.remove('visually-hidden');
      if (sizeRow) sizeRow.classList.remove('visually-hidden');
      if (rotationRow) rotationRow.classList.remove('visually-hidden');
      if (downloadBtn) {
        downloadBtn.disabled = false;
        downloadBtn.removeAttribute('aria-disabled');
      }
      applyPosition();
      applySize();
      applyRotation();
    }

    function hideLogo() {
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      logoImg.removeAttribute('src');
      logoImg.removeAttribute('alt');
      lastUploadedFile = null;
      lastUploadDataUrl = null;
      clearStoredLogo();
      if (removeBtn) removeBtn.classList.add('visually-hidden');
      if (sizeRow) sizeRow.classList.add('visually-hidden');
      if (rotationRow) rotationRow.classList.add('visually-hidden');
      if (downloadBtn) {
        downloadBtn.disabled = true;
        downloadBtn.setAttribute('aria-disabled', 'true');
      }
      input.value = '';
      rotation = 0;
      if (rotationInput) rotationInput.value = 0;
      applyRotation();
    }

    function applyPosition() {
      logoEl.style.left = pos.left + '%';
      logoEl.style.top = pos.top + '%';
    }
    function applySize() {
      logoEl.style.width = size + '%';
    }
    function applyRotation() {
      logoEl.style.transform = 'rotate(' + rotation + 'deg)';
    }

    function getZoomViewportRect() {
      return zoomViewport ? zoomViewport.getBoundingClientRect() : { left: 0, top: 0, width: 0, height: 0 };
    }

    function applyZoom(focusViewportX, focusViewportY, newZoomValue) {
      if (!zoomInner || !zoomViewport) return;
      var r = getZoomViewportRect();
      var vx = focusViewportX != null ? focusViewportX : r.width / 2;
      var vy = focusViewportY != null ? focusViewportY : r.height / 2;
      var oldZoom = zoomLevel;
      if (newZoomValue != null) {
        zoomLevel = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, newZoomValue));
        var cx = (vx - zoomTranslateX) / oldZoom;
        var cy = (vy - zoomTranslateY) / oldZoom;
        zoomTranslateX = vx - cx * zoomLevel;
        zoomTranslateY = vy - cy * zoomLevel;
      } else {
        zoomLevel = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, zoomLevel));
        var cx = (vx - zoomTranslateX) / zoomLevel;
        var cy = (vy - zoomTranslateY) / zoomLevel;
        zoomTranslateX = vx - cx * zoomLevel;
        zoomTranslateY = vy - cy * zoomLevel;
      }
      applyZoomTransform();
    }

    function applyZoomTransform() {
      if (!zoomInner) return;
      zoomInner.style.transform = 'translate(' + zoomTranslateX + 'px,' + zoomTranslateY + 'px) scale(' + zoomLevel + ')';
      if (zoomViewport) {
        if (zoomLevel > 1) zoomViewport.classList.add('logo-preview-zoom-viewport--pannable');
        else zoomViewport.classList.remove('logo-preview-zoom-viewport--pannable', 'logo-preview-zoom-viewport--panning');
      }
    }

    function isLogoOrInsideLogo(el) {
      return el && (el === logoEl || logoEl.contains(el));
    }

    function startPan(clientX, clientY) {
      if (zoomLevel <= 1) return;
      pan = { startX: clientX, startY: clientY, startTranslateX: zoomTranslateX, startTranslateY: zoomTranslateY };
      if (zoomViewport) zoomViewport.classList.add('logo-preview-zoom-viewport--panning');
    }

    function movePan(clientX, clientY) {
      if (!pan) return;
      zoomTranslateX = pan.startTranslateX + (clientX - pan.startX);
      zoomTranslateY = pan.startTranslateY + (clientY - pan.startY);
      applyZoomTransform();
    }

    function endPan() {
      if (pan && zoomViewport) zoomViewport.classList.remove('logo-preview-zoom-viewport--panning');
      pan = null;
    }

    function getOverlayRect() {
      return overlay.getBoundingClientRect();
    }
    function startDrag(clientX, clientY) {
      var rect = getOverlayRect();
      drag = { startX: clientX, startY: clientY, startLeft: pos.left, startTop: pos.top, rectWidth: rect.width, rectHeight: rect.height };
    }
    function moveDrag(clientX, clientY) {
      if (!drag) return;
      var dx = ((clientX - drag.startX) / drag.rectWidth) * 100;
      var dy = ((clientY - drag.startY) / drag.rectHeight) * 100;
      var rect = getOverlayRect();
      var logoH = logoEl.offsetHeight;
      var heightPercent = rect.height ? (logoH / rect.height) * 100 : size;
      var minTop = 0;
      var maxTop = Math.max(minTop, 100 - heightPercent);
      var minLeft = 0;
      var maxLeft = Math.max(minLeft, 100 - size);
      pos.left = Math.min(maxLeft, Math.max(minLeft, drag.startLeft + dx));
      pos.top = Math.min(maxTop, Math.max(minTop, drag.startTop + dy));
      applyPosition();
    }
    function endDrag() { drag = null; }

    function validateFile(file) {
      if (!file || !file.type) return false;
      for (var i = 0; i < ALLOWED_TYPES.length; i++) {
        if (file.type === ALLOWED_TYPES[i]) return true;
      }
      if (file.type.indexOf('image/') === 0) return true;
      return false;
    }

    function invisibleUploadLogo(file) {
      if (!webhookBase || !file) return;
      var uploadUrl = webhookBase + '/upload-logo';
      compressImage(file).then(function (blob) {
        resolveCartToken(modal).then(function (cartToken) {
          var fd = new FormData();
          fd.append('logo', blob, file.name || 'logo.jpg');
          if (modal.dataset.productId) fd.append('product_id', modal.dataset.productId);
          if (modal.dataset.productTitle) fd.append('product_title', modal.dataset.productTitle);
          var color = getSelectedColor();
          if (color) fd.append('color', color);
          var visitorId = getVisitorId();
          var uploadSessionId = getUploadSessionId();
          var customerId = modal.dataset.shopifyCustomerId || '';
          if (visitorId) fd.append('visitor_id', visitorId);
          if (uploadSessionId) fd.append('upload_session_id', uploadSessionId);
          if (customerId) fd.append('customer_id', customerId);
          if (cartToken) fd.append('cart_token', cartToken);
          sendToBackend(uploadUrl, fd);
        });
      });
    }

    input.addEventListener('change', function () {
      var file = this.files && this.files[0];
      if (!file || !validateFile(file)) return;
      var reader = new FileReader();
      reader.onload = function () {
        lastUploadDataUrl = reader.result;
        lastUploadedFile = file;
        logoImg.src = lastUploadDataUrl;
        logoImg.alt = file.name || 'Your logo';
        showLogo();
        invisibleUploadLogo(file);
        setStoredLogo(lastUploadDataUrl);
      };
      reader.readAsDataURL(file);
    });

    if (removeBtn) removeBtn.addEventListener('click', hideLogo);

    if (sizeInput) {
      sizeInput.value = size;
      sizeInput.addEventListener('input', function () {
        var newSize = Number(this.value);
        var rect = getOverlayRect();
        var w = logoEl.offsetWidth;
        var h = logoEl.offsetHeight;
        if (!rect.height || !w) {
          size = newSize;
          applySize();
          return;
        }
        var widthPercent = size;
        var heightPercent = (h / rect.height) * 100;
        var centerX = pos.left + widthPercent / 2;
        var centerY = pos.top + heightPercent / 2;
        var aspectRatio = h / w;
        size = newSize;
        var newHeightPercent = newSize * (rect.width / rect.height) * aspectRatio;
        var newLeft = centerX - size / 2;
        var newTop = centerY - newHeightPercent / 2;
        var maxTopSize = Math.max(0, 100 - newHeightPercent);
        pos.left = Math.min(100 - size, Math.max(0, newLeft));
        pos.top = Math.min(maxTopSize, Math.max(0, newTop));
        applyPosition();
        applySize();
      });
    }
    if (rotationInput) {
      rotationInput.value = rotation;
      rotationInput.addEventListener('input', function () {
        rotation = Number(this.value);
        applyRotation();
      });
    }

    if (zoomViewport && zoomInner) {
      zoomViewport.addEventListener('wheel', function (e) {
        e.preventDefault();
        var r = getZoomViewportRect();
        var vx = e.clientX - r.left;
        var vy = e.clientY - r.top;
        var newZoom = e.deltaY > 0 ? zoomLevel - ZOOM_STEP : (e.deltaY < 0 ? zoomLevel + ZOOM_STEP : zoomLevel);
        applyZoom(vx, vy, newZoom);
      }, { passive: false });

      zoomViewport.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) {
          pinchStartDist = Math.hypot(e.touches[1].clientX - e.touches[0].clientX, e.touches[1].clientY - e.touches[0].clientY);
          pinchStartZoom = zoomLevel;
        }
      }, { passive: true });

      zoomViewport.addEventListener('touchmove', function (e) {
        if (e.touches.length === 2 && pinchStartDist != null && pinchStartZoom != null) {
          e.preventDefault();
          var r = getZoomViewportRect();
          var dist = Math.hypot(e.touches[1].clientX - e.touches[0].clientX, e.touches[1].clientY - e.touches[0].clientY);
          var scale = dist / pinchStartDist;
          var newZoom = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, pinchStartZoom * scale));
          var centerX = (e.touches[0].clientX + e.touches[1].clientX) / 2 - r.left;
          var centerY = (e.touches[0].clientY + e.touches[1].clientY) / 2 - r.top;
          applyZoom(centerX, centerY, newZoom);
        }
      }, { passive: false });

      zoomViewport.addEventListener('touchend', function (e) {
        if (e.touches.length < 2) {
          pinchStartDist = null;
          pinchStartZoom = null;
        }
      }, { passive: true });

      zoomViewport.addEventListener('mousedown', function (e) {
        if (e.button !== 0 || zoomLevel <= 1 || isLogoOrInsideLogo(e.target)) return;
        e.preventDefault();
        startPan(e.clientX, e.clientY);
        var onMove = function (ev) { movePan(ev.clientX, ev.clientY); };
        var onUp = function () {
          document.removeEventListener('mousemove', onMove);
          document.removeEventListener('mouseup', onUp);
          endPan();
        };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
      });

      zoomViewport.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1 || zoomLevel <= 1 || isLogoOrInsideLogo(e.target)) return;
        startPan(e.touches[0].clientX, e.touches[0].clientY);
        var onMove = function (ev) {
          if (ev.touches.length === 1 && pan) {
            ev.preventDefault();
            movePan(ev.touches[0].clientX, ev.touches[0].clientY);
          }
        };
        var onEnd = function () {
          document.removeEventListener('touchmove', onMove, { passive: false });
          document.removeEventListener('touchend', onEnd);
          endPan();
        };
        document.addEventListener('touchmove', onMove, { passive: false });
        document.addEventListener('touchend', onEnd);
      }, { passive: true });
    }

    if (zoomOutBtn) {
      zoomOutBtn.addEventListener('click', function () {
        applyZoom(null, null, zoomLevel - ZOOM_STEP);
      });
    }
    if (zoomInBtn) {
      zoomInBtn.addEventListener('click', function () {
        applyZoom(null, null, zoomLevel + ZOOM_STEP);
      });
    }
    if (zoomResetBtn) {
      zoomResetBtn.addEventListener('click', function () {
        zoomLevel = 1;
        zoomTranslateX = 0;
        zoomTranslateY = 0;
        applyZoomTransform();
      });
    }

    modal.addEventListener('click', function (e) {
      var swatch = e.target && e.target.closest && e.target.closest('.logo-preview-swatch');
      if (!swatch) return;
      var url = swatch.getAttribute('data-image-url');
      if (!url) return;
      var modalEl = swatch.closest('.logo-preview-modal');
      var mainImg = modalEl && modalEl.querySelector('.logo-preview-modal__product-image');
      if (!mainImg) return;
      if (url.indexOf('//') === 0) url = window.location.protocol + url;
      mainImg.src = url;
      var allSwatches = modalEl.querySelectorAll('.logo-preview-swatch');
      allSwatches.forEach(function (s) {
        s.classList.remove('is-active');
        s.setAttribute('aria-pressed', 'false');
      });
      swatch.classList.add('is-active');
      swatch.setAttribute('aria-pressed', 'true');
    });

    logoEl.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      e.preventDefault();
      startDrag(e.clientX, e.clientY);
      var onMove = function (ev) { moveDrag(ev.clientX, ev.clientY); };
      var onUp = function () {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        endDrag();
      };
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    });
    logoEl.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      e.preventDefault();
      startDrag(e.touches[0].clientX, e.touches[0].clientY);
      var onMove = function (ev) {
        if (ev.touches.length === 1) moveDrag(ev.touches[0].clientX, ev.touches[0].clientY);
      };
      var onEnd = function () {
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onEnd);
        endDrag();
      };
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('touchend', onEnd);
    }, { passive: false });

    function setEmailError(message) {
      if (!emailErrorEl) return;
      if (message) {
        emailErrorEl.textContent = message;
        emailErrorEl.hidden = false;
      } else {
        emailErrorEl.textContent = '';
        emailErrorEl.hidden = true;
      }
    }

    function getEmail() {
      if (!emailInput) return '';
      var val = (emailInput.value || '').trim();
      if (!val) {
        if (askEmail) setEmailError('Add your email to receive your design');
        else setEmailError('');
        return '';
      }
      var at = val.indexOf('@');
      if (at < 1 || val.indexOf('.', at) < at + 2) {
        if (askEmail) setEmailError('Add your email to receive your design');
        else setEmailError('');
        return '';
      }
      setEmailError('');
      return val;
    }

    function getSelectedColor() {
      var active = modal.querySelector('.logo-preview-swatch.is-active') || modal.querySelector('.logo-preview-swatch[aria-pressed="true"]');
      if (!active) return '';
      var name = (active.getAttribute('title') || (active.querySelector('.js-value') && active.querySelector('.js-value').textContent) || active.getAttribute('data-swatch') || '').trim();
      return name;
    }

    function sanitizeFilenamePart(s) {
      return (s || '').replace(/[\s\\/:*?"<>|]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '') || 'preview';
    }

    function buildMockupBlob(cb) {
      var wrap = modal.querySelector('.logo-preview-modal__image-wrap');
      var img = productImage;
      var logo = logoImg;
      if (!wrap || !img || !logo.src) {
        cb(null);
        return;
      }
      var imgW = img.naturalWidth || img.width;
      var imgH = img.naturalHeight || img.height;
      if (!imgW || !imgH) {
        cb(null);
        return;
      }
      var logoW = logo.naturalWidth || logo.width || 1;
      var logoH = logo.naturalHeight || logo.height || 1;
      if (!logoW) logoW = 1;
      if (!logoH) logoH = 1;
      try {
        var c = document.createElement('canvas');
        var maxW = 1200;
        var scale = imgW > maxW ? maxW / imgW : 1;
        c.width = Math.round(imgW * scale);
        c.height = Math.round(imgH * scale);
        var ctx = c.getContext('2d');
        if (!ctx) {
          cb(null);
          return;
        }
        ctx.drawImage(img, 0, 0, c.width, c.height);
        var lLeft = (pos.left / 100) * c.width;
        var lTop = (pos.top / 100) * c.height;
        var lW = (size / 100) * c.width;
        var lH = lW * (logoH / logoW);
        ctx.save();
        ctx.translate(lLeft + lW / 2, lTop + lH / 2);
        ctx.rotate((rotation * Math.PI) / 180);
        ctx.translate(-lW / 2, -lH / 2);
        ctx.shadowColor = 'rgba(0,0,0,0.25)';
        ctx.shadowBlur = Math.max(2, Math.round(lW * 0.01));
        ctx.shadowOffsetX = Math.max(1, Math.round(lW * 0.008));
        ctx.shadowOffsetY = Math.max(1, Math.round(lW * 0.008));
        ctx.drawImage(logo, 0, 0, lW, lH);
        ctx.shadowColor = 'transparent';
        ctx.shadowBlur = 0;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        ctx.drawImage(logo, 0, 0, lW, lH);
        ctx.globalCompositeOperation = 'source-atop';
        var grainSize = Math.max(2, Math.min(3, Math.round(lW / 100)));
        for (var gx = 0; gx < lW; gx += grainSize) {
          for (var gy = 0; gy < lH; gy += grainSize) {
            var r = Math.random();
            if (r < 0.15) {
              ctx.fillStyle = 'rgba(255,255,255,0.03)';
              ctx.fillRect(gx, gy, grainSize, grainSize);
            } else if (r < 0.3) {
              ctx.fillStyle = 'rgba(0,0,0,0.02)';
              ctx.fillRect(gx, gy, grainSize, grainSize);
            }
          }
        }
        ctx.globalCompositeOperation = 'source-over';
        ctx.restore();

        var watermarkUrl = (modal.dataset.downloadWatermarkUrl || '').trim();
        if (watermarkUrl) {
          var wmImg = new Image();
          wmImg.crossOrigin = 'anonymous';
          wmImg.onerror = function () {
            c.toBlob(function (blob) { cb(blob || null); }, 'image/png', 1);
          };
          wmImg.onload = function () {
            try {
              var cw = c.width;
              var ch = c.height;
              var pad = Math.max(8, Math.round(Math.min(cw, ch) * 0.02));
              var maxW = Math.round(cw * 0.14);
              var maxH = Math.round(ch * 0.08);
              var ww = wmImg.naturalWidth || wmImg.width || 1;
              var wh = wmImg.naturalHeight || wmImg.height || 1;
              if (!ww) ww = 1;
              if (!wh) wh = 1;
              var scale = Math.min(maxW / ww, maxH / wh, 1);
              var drawW = Math.round(ww * scale);
              var drawH = Math.round(wh * scale);
              var x = cw - pad - drawW;
              var y = ch - pad - drawH;
              ctx.save();
              ctx.globalAlpha = 0.22;
              ctx.drawImage(wmImg, x, y, drawW, drawH);
              ctx.restore();
            } catch (e) {}
            c.toBlob(function (blob) { cb(blob || null); }, 'image/png', 1);
          };
          wmImg.src = watermarkUrl;
        } else {
          c.toBlob(function (blob) {
            cb(blob || null);
          }, 'image/png', 1);
        }
      } catch (err) {
        cb(null);
      }
    }

    function runWhenProductImageReady(fn) {
      if (productImage.complete && productImage.naturalWidth > 0) {
        fn();
        return;
      }
      var once = function () {
        productImage.removeEventListener('load', once);
        productImage.removeEventListener('error', once);
        fn();
      };
      productImage.addEventListener('load', once);
      productImage.addEventListener('error', once);
    }

    if (emailInput) {
      emailInput.addEventListener('input', function () {
        setEmailError('');
      });
    }

    if (downloadBtn) {
      downloadBtn.addEventListener('click', function () {
        if (!lastUploadDataUrl || !logoImg.src) return;
        if (downloadBtn.disabled && downloadBtn.getAttribute('aria-busy') === 'true') return;
        downloadBtn.disabled = true;
        downloadBtn.setAttribute('aria-busy', 'true');
        var done = function () {
          downloadBtn.disabled = false;
          downloadBtn.removeAttribute('aria-busy');
        };
        var emailForRequest = getEmail();
        if (askEmail && !emailForRequest) {
          done();
          if (emailInput) emailInput.focus();
          return;
        }
        runWhenProductImageReady(function () {
          buildMockupBlob(function (mockupBlob) {
            if (!mockupBlob) {
              done();
              return;
            }
            var productNamePart = sanitizeFilenamePart(modal.dataset.productTitle || '');
            var filename = productNamePart + '-mockup-by-WearForm-' + Date.now() + '.png';
            var a = document.createElement('a');
            a.href = URL.createObjectURL(mockupBlob);
            a.download = filename;
            a.click();
            URL.revokeObjectURL(a.href);
            if (webhookBase) {
              resolveCartToken(modal).then(function (cartToken) {
                var fd = new FormData();
                fd.append('mockup', mockupBlob, filename);
                if (lastUploadedFile) fd.append('logo', lastUploadedFile, lastUploadedFile.name || 'logo.jpg');
                else if (lastUploadDataUrl) {
                  var blob = dataUrlToBlob(lastUploadDataUrl);
                  if (blob) fd.append('logo', blob, 'logo.png');
                }
                if (emailForRequest) fd.append('email', emailForRequest);
                if (modal.dataset.productId) fd.append('product_id', modal.dataset.productId);
                if (modal.dataset.productTitle) fd.append('product_title', modal.dataset.productTitle);
                var color = getSelectedColor();
                if (color) fd.append('color', color);
                var visitorId = getVisitorId();
                var uploadSessionId = getUploadSessionId();
                var customerId = modal.dataset.shopifyCustomerId || '';
                if (visitorId) fd.append('visitor_id', visitorId);
                if (uploadSessionId) fd.append('upload_session_id', uploadSessionId);
                if (customerId) fd.append('customer_id', customerId);
                if (cartToken) fd.append('cart_token', cartToken);
                sendToBackend(webhookBase + '/download-mockup', fd);
              });
            }
            done();
          });
        });
      });
    }

    function closeAndPersist() {
      if (lastUploadDataUrl) {
        setStoredLogo(lastUploadDataUrl, {
          position: { left: pos.left, top: pos.top },
          size: size,
          rotation: rotation
        });
      }
      closeModal(modal);
    }

    trigger.addEventListener('click', function () {
      openModal(modal);
      zoomLevel = 1;
      zoomTranslateX = 0;
      zoomTranslateY = 0;
      applyZoom();
      var stored = getStoredLogo();
      if (stored && stored.dataUrl) {
        var testImg = new Image();
        testImg.onerror = function () { clearStoredLogo(); };
        testImg.onload = function () {
          logoImg.src = stored.dataUrl;
          logoImg.alt = 'Your logo';
          lastUploadDataUrl = stored.dataUrl;
          lastUploadedFile = null;
          showLogo();
          if (stored.position) {
            pos.left = stored.position.left;
            pos.top = stored.position.top;
            applyPosition();
          }
          if (stored.size != null) {
            size = stored.size;
            if (sizeInput) sizeInput.value = size;
            applySize();
          }
          if (stored.rotation != null) {
            rotation = stored.rotation;
            if (rotationInput) rotationInput.value = rotation;
            applyRotation();
          }
        };
        testImg.src = stored.dataUrl;
      }
    });
    if (closeButtons && closeButtons.length) {
      closeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () { closeAndPersist(); });
      });
    }
    modal.addEventListener('click', function (e) {
      if (e.target === modal.querySelector('.logo-preview-modal__backdrop')) closeAndPersist();
    });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAndPersist();
      else trapFocus(modal, e);
    });
  }

  function dataUrlToBlob(dataUrl) {
    try {
      var parts = dataUrl.split(',');
      var mime = parts[0].match(/:(.*?);/);
      if (!mime) return null;
      var bstr = atob(parts[1]);
      var n = bstr.length;
      var u8 = new Uint8Array(n);
      for (var i = 0; i < n; i++) u8[i] = bstr.charCodeAt(i);
      return new Blob([u8], { type: mime[1] });
    } catch (err) {
      return null;
    }
  }

  function init() {
    fetchCartToken();
    document.querySelectorAll('.logo-preview-trigger-wrap[data-section-id]').forEach(initLogoPreview);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
